<template>
  <v-overlay v-model="$store.getters.GET_PAGE_LOADING"
             absolute opacity="1"
             color="primary"
             z-index="999">
    <v-row class="ma-0 pa-0 fill-height d-flex justify-center align-center">
      <v-col cols="5" class="d-flex justify-center">
        <v-progress-circular width="8" size="300" color="white" indeterminate>
          <v-img max-width="90%" src="@/assets/logo_circle_white.png"
                 alt="NITG Helpdesk Page Loading Logo" />
        </v-progress-circular>
      </v-col>
    </v-row>
  </v-overlay>
</template>

<script>
export default {
  name: "LoadingPageComponent"
}
</script>

<style scoped>

</style>
